import { useCallback, useEffect, useState } from 'react';
import { fetchEmployees } from '../api';

export const useEmployees = () => {
  const [employees, setEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const refresh = useCallback(() => {
    setRefreshKey((value) => value + 1);
  }, []);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await fetchEmployees();
        if (isMounted) {
          setEmployees(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.warn('Failed to load employees', err);
        if (isMounted) {
          setError('Не удалось загрузить сотрудников.');
          setEmployees([]);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [refreshKey]);

  return { employees, isLoading, error, refresh };
};

export default useEmployees;
